import { authenticatedPost, authenticatedGet } from "../../../Services/core";

export const list = async (request) => {
   return await authenticatedPost(request,process.env.REACT_APP_BASE_URL+'users/listmsgusers');
}
